import React, { useState } from "react";
import {
  Box,
  Button,
  Container,
  HStack,
  Icon,
  Text,
  VStack,
} from "@chakra-ui/react";
import Logo from "components/Logo";
import { getShortenedAddress } from "utils/walletUtils";
import useConnectedAccount from "hooks/useConnectedAccount";
import EthIcon from "components/EthIcon";
import WalletPopup from "components/WalletPopup";
import useAssets from "hooks/useAssets";
import { Link } from "react-router-dom";
import WalletAssetsContainer from "components/WalletAssetsContainer";
import MainMenu from "components/MainMenu";

const Header: React.FC = () => {
  const [address] = useConnectedAccount();
  const { formattedBalance } = useAssets();
  const [isWalletDialogVisible, setIsWalletDialogVisible] = useState(false);

  return (
    <>
      <Box as="header" bg="dark.500" color="bright.400" pt="6">
        <Container>
          <VStack align="stretch" spacing="6">
            <HStack justify="space-between" overflow="hidden">
              <Link to="/">
                <Logo />
              </Link>

              {address && (
                <HStack spacing="6">
                  <HStack gap="0.5">
                    <Icon as={EthIcon} w="3" h="auto" />
                    <Text>
                      {formattedBalance
                        ? formattedBalance.substring(0, 6)
                        : "–"}
                    </Text>
                  </HStack>

                  <Button
                    color="bright.500"
                    borderColor="dark.400"
                    _hover={{
                      borderColor: "secondary.500",
                    }}
                    colorScheme="bright"
                    borderRadius="full"
                    variant="outline"
                    size="sm"
                    onClick={() => setIsWalletDialogVisible(true)}
                  >
                    <Text fontWeight="semibold" fontSize="sm">
                      {getShortenedAddress(address, 3)}
                    </Text>
                  </Button>
                </HStack>
              )}
            </HStack>
            <VStack spacing="3" w="full" align="stretch">
              <WalletAssetsContainer />
              <MainMenu />
            </VStack>
          </VStack>
        </Container>
      </Box>

      {address && (
        <WalletPopup
          isOpen={isWalletDialogVisible}
          onClose={() => setIsWalletDialogVisible(false)}
        />
      )}
    </>
  );
};

export default Header;
